import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import BackButton from "@/components/BackButton";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            const u = await login(email, password);
            toast.success("Bentornato.");
            if (u.role === "admin") navigate("/admin/vini");
            else navigate(location.state?.from || "/");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Accesso non riuscito.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="co-container py-14 sm:py-20 max-w-md" data-testid="login-page">
            <div className="mb-4"><BackButton testid="login-back-btn" /></div>
            <span className="co-caption">Accesso Riservato</span>
            <h1 className="font-serif text-4xl mt-2 mb-8">Accedi al tuo account</h1>

            <form onSubmit={submit} className="space-y-5">
                <div>
                    <Label htmlFor="email" className="co-caption mb-2 block">Email</Label>
                    <Input
                        id="email" type="email" required autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="login-email-input"
                        className="bg-white h-11"
                    />
                </div>
                <div>
                    <div className="flex items-baseline justify-between mb-2">
                        <Label htmlFor="password" className="co-caption">Password</Label>
                        <Link
                            to="/password-dimenticata"
                            data-testid="login-forgot-link"
                            className="text-xs text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))] transition-colors"
                        >
                            Password dimenticata?
                        </Link>
                    </div>
                    <Input
                        id="password" type="password" required autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        data-testid="login-password-input"
                        className="bg-white h-11"
                    />
                </div>

                {error && (
                    <p className="text-sm text-[hsl(var(--destructive))]" data-testid="login-error">
                        {error}
                    </p>
                )}

                <button type="submit" disabled={busy} className="co-btn-primary w-full h-12" data-testid="login-submit-btn">
                    {busy ? "Accesso in corso…" : "Accedi"}
                </button>
            </form>

            <p className="mt-8 text-sm text-[hsl(var(--muted-foreground))]">
                Non hai un account?{" "}
                <Link to="/register" className="text-[hsl(var(--primary))] hover:underline underline-offset-4">
                    Registrati
                </Link>
            </p>
        </div>
    );
}
